import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { ADD_TO_CART, UPDATE_CART_QUANTITY } from "../../utils/actions";
import { idbPromise } from "../../utils/helpers";

function ProductItem(product) {
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart); // read Redux state

  const {
    image,
    name,
    _id,
    price_usd,
    description,
    weight,
    in_stock
  } = product.product;

  const addToCart = () => {
    const itemInCart = cart.find((cartItem) => cartItem._id === _id)
    if (itemInCart) {

      // Because we keep a persistent cart copy in IndexedDB,
      // it must be updated in both Redux and IndexedDB.

      dispatch({
        type: UPDATE_CART_QUANTITY,
        _id: _id,
        purchaseQuantity: parseInt(itemInCart.purchaseQuantity) + 1
      });
      idbPromise('cart', 'put', {
        ...itemInCart,
        purchaseQuantity: parseInt(itemInCart.purchaseQuantity) + 1
      });

    } else {
      dispatch({
        type: ADD_TO_CART,
        // Assume in stock if it is in product listing page
        product: { ...product.product, purchaseQuantity: 1, inStock: true }
      });
      idbPromise('cart', 'put', { ...product.product, purchaseQuantity: 1 });
    }
  }

  return (
    <div className="card p-2 m-2">
      <Link to={`/products/${_id}`}>
        <img alt={name} src={`/images/${image}`} />
        <h3>{name}</h3>
      </Link>
      <div>
        <p>{description}</p>
      </div>
      <div>
        <span>${price_usd} per {weight}</span>
      </div>
      {in_stock ? (<button onClick={addToCart}>Add to cart</button>)
                : (<div className="out-of-stock">Out of stock</div>)}

    </div>
  );
}

export default ProductItem;
